module.exports = __webpack_public_path__ + "img/img13.5300e1d9.jpg";